import { GAME_ID, ACTION_TYPES, LEVEL_MODES, GRID_COORDINATES } from 'a/stickerBook/data/constants';

/**
 * This reducer manages the state needed to play a round of the activity.
 */

const initialState = {
  level: 0,
  // Overall ability to drag and drop
  isDraggable: false,
  stickers: [],
  mode: LEVEL_MODES.PICTURES,
  // Whether or not definition mode is active
  isDefinitionMode: false,
  correctSceneId: undefined,
  // For keyboard a11y features
  keyboardSelectedSticker: undefined,
  keyboardSelectedScene: undefined,
};

export default (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case ACTION_TYPES.LOAD_LEVEL: {
      const { level, scenes, stickers, mode, questSet } = payload;
      return {
        ...initialState,
        level,
        scenes: [...scenes],
        [scenes[0].sceneId]: [],
        [scenes[1].sceneId]: [],
        stickers: [...stickers],
        mode,
        questSet,
      };
    }
    case ACTION_TYPES.SET_DRAGGABLE_STATE:
      return { ...state, isDraggable: payload };
    case ACTION_TYPES.DROP_STICKER: {
      const { sceneId, stickerData, isCorrect, correctSceneId } = payload;
      const { word } = stickerData;

      if (!isCorrect) {
        const stickers = [...state.stickers];
        const index = state.stickers.findIndex(({ word: id }) => word === id);
        const incorrectAttempts = stickerData.incorrectAttempts || 0;
        stickers[index] = { ...stickerData, incorrectAttempts: incorrectAttempts + 1 };
        return { ...state, stickers, correctSceneId };
      }

      const stickers = state.stickers.filter(({ word: id }) => word !== id);
      const scene = state[sceneId] || [];
      const newScene = scene.filter(({ word: id }) => id !== word);

      if (stickerData.top === undefined || stickerData.left === undefined) {
        newScene.push({
          ...stickerData,
          keyboardDropCss: GRID_COORDINATES[newScene.length],
        });
      } else {
        newScene.push(stickerData);
      }

      return { ...state, [sceneId]: newScene, stickers };
    }
    case ACTION_TYPES.SELECT_STICKER_VIA_KEYBOARD:
      return {
        ...state,
        keyboardSelectedSticker: payload.stickerData,
        keyboardSelectedScene: payload.stickerData ? state.keyboardSelectedScene : undefined,
      };
    case ACTION_TYPES.CYCLE_SCENE_VIA_KEYBOARD: {
      const { increment } = payload;

      if (state.keyboardSelectedScene === undefined) {
        return { ...state, keyboardSelectedScene: 0 };
      }

      const index = state.keyboardSelectedScene + increment;
      if (index < 0) {
        return { ...state, keyboardSelectedScene: 1 };
      }
      if (index > 1) {
        return { ...state, keyboardSelectedScene: 0 };
      }
      return { ...state, keyboardSelectedScene: index };
    }
    case ACTION_TYPES.CLEAR_SCENE_FEEDBACK:
      return { ...state, correctSceneId: undefined };
    case ACTION_TYPES.TOGGLE_DEFINITION_MODE:
      return {
        ...state,
        isDefinitionMode: !state.isDefinitionMode,
      };
    default:
      return state;
  }
};
